import { render } from "./errorPage404.vue?vue&type=template&id=4e4ea1fc"
import script from "./errorPage404.vue?vue&type=script&lang=js"
export * from "./errorPage404.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__